<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  leftData2: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {
  initChart(props.leftData2);
});

function initChart(leftData2) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);

  const option= {
      color: ["#ffc20e", "#00ae9d"],
      grid: {
         top: "25%",
         left: "5%",
         right: "5%",
         bottom: "0%",
         containLabel: true
      },
      legend: {
         right: "center",
         top:"5%",
         icon: "circle",
         itemWidth: 8,
         itemGap: 20,
         textStyle: {
            padding: [0, 0, 0, 5],
            color:"#fff",
            fontSize:14
         }
      },
      tooltip: {
         trigger: "axis",
        extraCssText:'z-index:0',
         backgroundColor: "rgba(61, 85, 102, 1)",
         borderWidth: 1,
         borderColor: "#9DBAE1", // 边框颜色
         // 选中线颜色
         axisPointer: {
            lineStyle: {
               color: "#9DBAE1"
            }
         },
         // 字体颜色
         textStyle: {
            color: "#fff",
            fontSize: 14
         },
         formatter: function(params) {
            let str = params[0].name + '<br/>';
            params.forEach(item => {
                if (item.seriesName == '温度') {
                    str += item.marker + item.seriesName + ': ' + item.data +'℃'+ '<br/>';
                } else if (item.seriesName == "湿度") {
                    str += item.marker + item.seriesName + ': ' + item.data + '%';
                }
            });
            return str;
        }
      },
      xAxis: [
         {
            type: "category",
            boundaryGap: false,
            axisLabel: {
               color: "#fff",
               fontSize: 14
            },
            axisLine: {
               lineStyle: {
                  color: "rgba(255,255,255,.1)"
               }
            },
            data: leftData2[0]
         }
      ],
      yAxis: [
         {
        name: '℃',
        nameTextStyle: {
            color: "#fff",
            fontSize: 16,
            padding:[20,0,0,0]
        },

        splitLine: {
            show: true,
            lineStyle: {
                color: 'rgba(124,155,183,.5)',
                type:'dashed'
            },
        },
        axisLine: {
            show: false,
        },
        axisLabel: {
            show: true,
            textStyle: {
                color: '#fff',
                padding: 0
            },
        },
        axisTick: {
            show: false,
        },
    },
       {
      type: 'value',
      name: '%',
      min:0,
      max:100,
      nameTextStyle: {
         color: '#fff',
         fontSize: 16,
         padding: [16,0,0,0]
      },
      axisLine: { show: false },
      axisTick: {show: false },
      axisLabel: {
        show: true,
        color: '#fff',
        fontSize: 14,
        padding: [10,0,0,0],
      },
      splitLine: { show: false }
    }
      ],
      series: [
         {
            name: "温度",
            type: "line",
            smooth: true, // 是否平滑曲线显示
            symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            symbolSize: 0,
            yAxisIndex: 0,
            itemStyle:{
               normal:{
                  color:'#00D0DC',//拐点颜色
                  // borderColor:'#fff',//拐点边框颜色
                  width:1//拐点边框大小
               },
               emphasis: {
                  shadowColor: "rgba(0,0,0, 0.8)", // 阴影颜色
                  shadowBlur: 20 //hover拐点颜色定义
               }
            },
            lineStyle: {
               normal: {
                  color: "#00D0DC" // 线条颜色
               }
            },
            areaStyle: {
               // 区域填充样式
               normal: {
                  // 线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                     [
                        { offset: 0, color: "rgba(0,215,225, 0.8)" },
                        { offset: 1, color: "rgba(0,215,225, 0)" }
                     ],
                     false
                  )
                  // shadowColor: "rgba(53,142,215, 0.9)", // 阴影颜色
                  // shadowBlur: 20 // shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
               }
            },
            data: leftData2[1]
         },
         {
            name: "湿度",
            type: "line",
            smooth: true, // 是否平滑曲线显示
            symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            symbolSize: 0,
            yAxisIndex: 1,
            lineStyle: {
               normal: {
                  color: "#00ae9d" // 线条颜色
               }
            },
            itemStyle:{
               normal:{
                  color:'#00ae9d',//拐点颜色
                  // borderColor:'#fff',//拐点边框颜色
                  width:0.1//拐点边框大小
               },
            },
            areaStyle: {
               // 区域填充样式
               normal: {
                  // 线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                     [
                        { offset: 0, color: "rgba(14,179,150, 0.8)" },
                        { offset: 1, color: "rgba(14,179,150, 0)" }
                     ],
                     false
                  )
                  // shadowColor: "rgba(53,142,215, 0.9)", // 阴影颜色
                  // shadowBlur: 20 // shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
               }
            },
            data: leftData2[2]
         }
      ]
    };// 将你的ECharts配置项放在这里
    chartInstance.setOption(option);

   // 其他各种图表一个原理
   let index = 0;
   setInterval(function () {
      // 这里的7 为x轴的长度
      if (index >= 7) {
         index = 0;
      }
      chartInstance.dispatchAction({
         type: "showTip", // 提示框
         seriesIndex: 0,
         dataIndex: index // 第 lightIndex 柱子高亮
      });
      index += 1;
   }, 2000);
}
  window.addEventListener("resize", () => {
    chartInstance.resize();
  });

</script>
<style lang="less"></style>
